module.exports = __webpack_public_path__ + "public/images/schedule/schedule-bel.51bb71dd9407a5c3381333e237a178c4.svg";